import React, { useState } from "react";
import { useNavigate } from "react-router";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

import ImageModal from "../../../components/images/ImageModal";
import useNotification from "../../../hooks/notification";
import { useAssetsCollection } from "../../../contexts/assetsCollection";
import useQuery from "../../../hooks/useQuery";
import useImageUploadWithAttachments from "../../../hooks/useImageUploadWithAttachments";
import ImageDND from "./ImageDND";
import ImagesSlider from "./ImagesSlider";
import { sortImages } from "../../../utils/images";

export default function Images({ asset: defaultAsset }) {
  const query = useQuery();
  const navigate = useNavigate();
  const { collection, updateImage, bulkCreateImages, removeImage } = useAssetsCollection();
  const asset = collection.find(v => v.id === defaultAsset.id);

  const { notifyError } = useNotification();
  const [loading, setLoading] = useState(false);
  const list = sortImages(asset?.images);
  const open = query.get("image") === "true";
  const defaultIndex = list.findIndex(v => v.default);
  const [index, setIndex] = useState(defaultIndex === -1 ? 0 : defaultIndex);

  // Use custom hook that automatically syncs shipment item attachments
  const handleBulkCreateImages = useImageUploadWithAttachments(asset, bulkCreateImages);

  const handleOpen = () => {
    if (list.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set("image", "true");
      navigate({ search: `?${params.toString()}` });
    }
  };

  const handleClose = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete("image");
    navigate({ search: params.toString() ? `?${params.toString()}` : "" });
  };

  const handleUpload = images => {
    setLoading(true);
    handleBulkCreateImages({
      variables: { assetId: asset.id, images },
      onSuccess: () => {
        setLoading(false);
      },
      onFailure: errors => {
        notifyError(errors);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <Box
        position="relative"
        onClick={handleOpen}
        sx={{
          width: { xs: "90%", sm: "50%", md: "90%" }, // Reduced width for asset details modal
          margin: "0 auto",
        }}
      >
        {list.length === 0 && (
          <>
            {loading && <LinearProgress />}
            <ImageDND onDrop={handleUpload} />
          </>
        )}
        <ImagesSlider list={list} index={index} onChangeIndex={setIndex} />
      </Box>
      {open && list[index] && (
        <ImageModal
          open
          closeOnSave={true}
          selectedId={list[index].id}
          asset={asset}
          images={list}
          onClose={handleClose}
          onRemove={removeImage}
          onUpdate={updateImage}
          onCreate={handleBulkCreateImages}
        />
      )}
    </>
  );
}
